module.exports = __webpack_public_path__ + "static/reportOutage_desktop-7a69608c3a5cdcff2f391cdb31d44ed3.png";